/**
 * Source-format detection (no React imports, so it's purely unit-testable). The source picker uses
 * this to auto-detect a picked file's parser and to filter/label recent candidates.
 */

/** Supported metadata-source extensions → parser format. `.xmp` sidecars parse through the XML adapter. */
export const FORMAT_BY_EXT: Record<string, string> = {
  csv: "csv",
  xlsx: "xlsx",
  xls: "xlsx",
  json: "json",
  xml: "xml",
  xmp: "xml",
};

export const FORMAT_LABELS: Record<string, string> = {
  csv: "CSV",
  xlsx: "XLSX",
  json: "JSON",
  xml: "XML",
};

/** The confidently-detected parser format for a filename, or undefined when the extension isn't a
 *  supported metadata-source type (the ambiguous / needs-override case). */
export function detectSourceFormat(title?: string): string | undefined {
  const ext = (title || "").toLowerCase().match(/\.([a-z0-9]+)$/)?.[1];
  return ext ? FORMAT_BY_EXT[ext] : undefined;
}
